import chrome_icon from '../assests/chrome_icon.png';
import delete_icon from '../assests/delete_image.png';
import add_icon from '../assests/add_icon.png';
import heart from '../assests/heart.png';
import styled, { css } from 'styled-components';
import placeholder_image from '../assests/placeholder_image.png';
import cropIcon from '../assests/crop.png';

const ImageContainer = styled.img`
    border-radius: 10px;
    margin-right: 25px;
    width: 150px;
    height: 150px;
`;

const ImageWrapper = styled.div`
    // width: 100%;
    position: relative;
`;

const ChromeImage = styled.img`
    position: absolute;
    top: 10px;
    right: 30px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    visibility: hidden;
    ${ImageWrapper}:hover & {
        visibility: visible;
    }
`;

const DeleteImage = styled.img`
    position: absolute;
    top: 125px;
    right: 150px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    border-color: white;
    visibility: hidden;
    ${ImageWrapper}:hover & {
        visibility: visible;
    }
`;

const CropImage = styled.img`
    position: absolute;
    top: 120px;
    right: 30px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    border-color: white;
    visibility: hidden;
    background-color: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 35px;
    ${ImageWrapper}:hover & {
        visibility: visible;
    }
`;

const HeartParent = styled.div`
  width: 15px;
  height: 15px;
  top: 15px;
    left: 5px;

  background-color: #ffffff;
  border: solid 3px #9b9b9b;
  position: absolute;
  border-radius: 35px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  visibility: hidden;
  ${props =>
    props.selected &&
    css`
      border: solid 3px #53e03f;
    `}
  ${ImageWrapper}:hover & {
    visibility: visible;
  }
`;

const InputParentDiv = styled.div`
  border-radius: 10px;
    margin-right: 25px;
    width: 150px;
    height: 150px;
    cursor: pointer;
    background-color: #d7d7d7;
`;

const AddImage = styled.img`
background-color: #d7d7d7;
  width: 72px;
  height: 72px;
  margin-top: 35px;
`;

const InputFile = styled.input`
  width: 150px;
  height: 150px;
  opacity: 0;
  left: 0;
  top: 0;
  position: absolute;
  cursor: pointer;

`;

const ImageWrapperSmall = (props) => {
  const handleChange = (event) => {
    const file = event.target.files[0];
    // props.addImage(URL.createObjectURL(file));
    const reader = new FileReader();

    reader.onload = (e) => {
      const base64String = e.target.result.split(',')[1];
      props.addImage(`data:image/jpeg;base64,${base64String}`, props.profileRef);

    };

    reader.readAsDataURL(file);
  };

  const openGoogleImages = (imageUrl) => {
    navigator.clipboard.writeText(imageUrl);
    window.open('https://www.google.com/imghp', '_blank');
  }

  return (
    <ImageWrapper>
      {
        props.src ? (
          <>
            <ImageContainer src={props.src.photo} onError={e => { e.target.src = placeholder_image }} alt="image" />
            <ChromeImage onClick={() => openGoogleImages(props.src.photo)} src={chrome_icon} alt="chrome" />
          </>
        ) : (
          <InputParentDiv>
            <AddImage src={add_icon} />
            <InputFile
              type="file"
              onChange={e => handleChange(e)}
              placeholder=""
              accept=""
            />
          </InputParentDiv>
        )
      }


      {
        props.src && props.showDelete ? (
          <DeleteImage src={delete_icon} alt="delete" onClick={() => props.deleteImage(props.profileRef, props.src.photo_id)} />
        ) : null
      }
      {
        props.src && props.showSelect ? (
          <HeartParent onClick={() => props.setSelected(props.profileRef, props.src.photo_id)} selected={props.src.selected}>{props.src.selected ? <img width={12} src={heart} /> : null}</HeartParent>
        ) : null
      }

      {
        props.src && props.showImageCrop ? (
          <CropImage src={cropIcon} onClick={() => {
            props.showImageCrop(props.src.photo);
            localStorage.setItem('profileCropRef', props.profileRef);
            localStorage.setItem('profileCropIndex', props.index);
          }} />
        ) : null

      }

    </ImageWrapper>
  );
}

export default ImageWrapperSmall;